// extracted by mini-css-extract-plugin
var _1 = "RequestProfileHeaderOwnerIcons-moduleicons__EqVFg";
export { _1 as "icons" }
